<template>
  <div class="d-flex flex-column flex-root" v-if="$store.getters['global/isLoaded']">
    <login-roll-back></login-roll-back>
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
            id="kt_content" style="margin-top: 15rem"
            class="content d-flex flex-column flex-column-fluid"
        >

          <!-- end:: Content Head -->
          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div :class="{'container-fluid': contentFluid,container: !contentFluid}">
              <div class="d-lg-flex flex-row-fluid">
                <!-- begin:: Aside Left -->
                <div class="d-block d-md-none">
                  <KTAside v-if="asideEnabled"></KTAside>
                </div>
                <!-- end:: Aside Left -->

                <div class="content-wrapper flex-row-fluid">
                  <transition name="fade-in-up">
                    <div>
                      <title-ribbon></title-ribbon>
                      <router-view/>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>

        <KTFooter></KTFooter>
      </div>
    </div>

<!--    <toast></toast>-->
<!--    <modal></modal>-->
    <rail-navigation></rail-navigation>
  <easy-modal></easy-modal>
  <navigation></navigation>

  <wallet :show-button="false"></wallet>


    <!--        <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>-->
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";
import wallet from "@/view/pages/transactions/wallet";
import titleRibbon from "@/view/layout/titleRibbon";




import { reformatMenuResponse } from '@/Utilities/MenuFunctions'

import LoginRollBack from "@/view/content/LoginRollBack";
import toast from "@/view/content/toast/toast";
import modal from "@/view/content/modals/modal";
import easyModal from "@/core/plugins/EasyModal/view";
import Navigation from '@/view/layout/aside/Navigation'
import RailNavigation from "@/view/content/RailNavigation";
export default {
  name: "Layout",
  components: {
    RailNavigation,
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader,
    LoginRollBack,
    toast,
    modal,
    easyModal,
    Navigation,
    wallet,
    titleRibbon
  },

  data() {
    return {
      text: [],
    }
  },

  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  watch: {
    $route(to, from) {
      // console.log(to.path);
      let footer = window.document.querySelector("#kt_footer")
      if (to.path == '/home'){
        footer.classList.add("manamanam")
      }else{
        footer.classList.remove("manamanam")
      }

      // this.authority();
      this.checkWalletAsync();
    },
  },
  created() {

    // let txt=JSON.parse(this.textMain)
      //
      // let texts = txt.map((i)=>{
      //   this.text.push(i.value.toString())
      //   return i.value;
      // })
      // this.text = texts;


    // this.requestApiGet('singleConfig',{'key':'mainText'}).then(response => {
    // // this.text=response.data
    //   let txt=JSON.parse(response.data)
    //
    //   let texts = txt.map((i)=>{
    //     this.text.push(i.value.toString())
    //     return i.value;
    //   })
    //   this.text = texts;
    // })
    // console.log("welcome to CORELAND!")

    //
    // let txt=JSON.parse(this.textMain)
    //
    // let texts = txt.map((i)=>{
    //   this.text.push(i.value.toString())
    //   return i.value;
    // })
    // this.text = texts;

    // this.authority()
    // this.getWallet();
    // this.checkWallet();



    // setInterval(() => {
    //   if (this.isAuthenticated) {
    //     this.checkWallet();
    //   }
    // }, 10000);
  },
  mounted() {


    // check if current user is authenticated
    // if (!this.isAuthenticated) {
    //   return this.$router.push({name: "login"});
    // }
    // let url = window.location.href;
    // const start = url.indexOf("?");
    // const end = url.indexOf("#");
    //
    // url = url.substring(start, end);
    // let fullUrl = document.URL;
    //
    // window.history.pushState('dashboard', 'Title', fullUrl.substr(end));
    // let token = localStorage.getItem('id_token');
    // if (url === '?redirect=qr') {
    //   return window.location.replace(`${this.qrUrl}?token=${token}`);
    // }
    // if(url === '?redirect=Pland'){
    //   return window.location.replace(`${this.pLandUrl}?token=${token}`);
    // }




    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);


  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),


    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return this.layoutConfig("loader.logo");
    },

    textMain() {
      return this.layoutConfig("mainText")

      // let t = this.layoutConfig("mainText") ?? [];
      //
      // let texts = t.map((i)=>{
      //   return i.value;
      // })
      // return texts;

        //
        // let t = JSON.parse(this.layoutConfig("mainText") ?? "[]") ?? [];
        //
        // console.log(t);
        //
        // let texts = []
        // for (const item of t) {
        //   if (item.value){
        //     texts.push(item.value);
        //   }
        // }


      // let t = JSON.parse(this.layoutConfig("mainText") ?? "[]") ?? [];
      //
      // let texts = []
      // for (const item of t) {
      //   if (item.value){
      //     texts.push(item.value);
      //   }
      // }
      // return texts;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  },
  methods:{
    test(){
      console.log(reformatMenuResponse(this.$store.getters['menu/items']))
    }
  }
};
</script>
